import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KrpanoViewComponent } from './krpano-view/krpano-view.component';
import { AppComponent } from './app.component';
import { IndexComponent } from './index/index.component';

const routes: Routes = [
  {
    path: 'home',
    component: KrpanoViewComponent
  },
  {
    path: 'room/:roomId',
    component: KrpanoViewComponent
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
